import React from 'react'
import {highlight, languages} from 'prismjs/components/prism-core'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-sql'
import {COLORS, HtmlView} from 'ac_ui'

interface ISolutionSqlProps {
  sql: string
  className?: string
}

const SolutionSql: React.FC<ISolutionSqlProps> = ({sql, className}): React.ReactElement => {
  const highlightCode = (code: string): string => {
    const res = highlight(code, languages.sql)
      .split('\n')
      .map((line: string, i: number) => {
        const lineNumber = i + 1
        let icon: string
        return `<span class="editorLineNumber unselectable">${icon || ''}${lineNumber}</span>${line}`
      })
      .join('\n')
    return `<pre aria-hidden="true"
                 class="solution-pre h-100"
                 style="margin: 0px;
                        border: 0px; 
                        background: none; 
                        box-sizing: inherit; 
                        display: inherit; 
                        font-family: inherit; 
                        font-size: inherit; 
                        font-style: inherit; 
                        font-variant-ligatures: inherit; 
                        font-weight: inherit; 
                        letter-spacing: inherit; 
                        line-height: inherit; 
                        tab-size: inherit; 
                        text-indent: inherit; 
                        text-rendering: inherit; 
                        text-transform: inherit; 
                        white-space: pre-wrap; 
                        word-break: keep-all; 
                        overflow-wrap: break-word; 
                        position: relative; 
                        pointer-events: none; 
                        padding: 0px;">${res}</pre>`
  }
  if (!sql) {
    return <></>
  }

  return (
    <div className={'solution-wrapper'}>
      <div
        className={'d-flex flex-column ' + className}
        style={{
          fontFamily: 'Menlo, Monaco, "Courier New", monospace',
          fontSize: '14px',
          lineHeight: '22px',
          height: '100%',
          outline: 'none',
          backgroundColor: COLORS.white,
        }}>
        <HtmlView className={''} html={sql ? highlightCode(sql) : ' '} />
        <div className={'editor-placeholder-wrapper flex-grow-1'}>
          <div className={'editor-placeholder'} />
        </div>
      </div>
    </div>
  )
}

export {SolutionSql}
